// Packages
import { createApp } from 'vue';
// Vue components
import ProductFilter from '@vue-components/ProductFilter.vue';

export default function init() {
  const productFilter = document.querySelector('#product-filter');

  const vueInstance = createApp({
    name: 'ProductFilterInstance',
    compilerOptions: {
      delimiters: ['${', '}'],
    },
    components: {
      ProductFilter,
    },
  });

  vueInstance.mount(productFilter);
}
